import React, { useEffect } from 'react';
import { Container, Typography } from "@mui/material";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import "./Address.css";
import { useSection } from '../../context/SectionContext';
import { useDatosUser } from "../../context/userContext";
import { useNavigate } from 'react-router-dom';
import useRedirectIframe from "../../hooks/useRedirectIframe";
import { URLS } from '../../context/urls'
import { ADDRESS_TEXTS } from './addressTexts';
import { useShippingAddresses } from '../../hooks/useShippingAddresses';
import AddressButton from './components/AddressButton/AddressButton';

function Address() {
    const navigate = useNavigate();
    const { changeSection } = useSection();
    const { nombre, completed, wuujuID } = useDatosUser();
    const { options, loading, error } = useShippingAddresses(wuujuID);

    useRedirectIframe(URLS.REDIRECT_IFRAME);

    useEffect(() => {
        if (completed === false || completed === null) {
            navigate('/crear-casillero-2');
        }
    }, [completed, navigate]);

    if (loading || !options) {
        return (
            <Container maxWidth="xl" className="center-container">
                <Typography sx={{ fontFamily: 'Viga', fontSize: { xs: '5vw', sm: '2vw' } }}>
                    Cargando direcciones...
                </Typography>
            </Container>
        );
    }

    return (
        <Container maxWidth="xl" className="center-container">
            <div className="center-content">
                <h1 className='Title-Wuuju'>{ADDRESS_TEXTS.MAIN_TITLE}</h1>
                <h3 className='Subtitle-address'>{nombre}, estas son tus <br /> direcciones en Miami</h3>
                <div className='button-container'>
                    {options.map((option, index) => (
                        <AddressButton
                            key={index}
                            icon={option.icon}
                            text={option.text}
                            color={option.color}
                            onClick={() => changeSection('DetallesDirecciones', option.name)}
                        />
                    ))}
                </div>

                <div className='typography-content'>
                    <Typography
                        sx={{
                            color: 'gray',
                            fontFamily: 'Viga, sans-serif',
                            fontSize: {xs: "3vw", sm: "1vw"},
                            position: 'relative',
                            zIndex: 1,
                        }}
                    >
                        {ADDRESS_TEXTS.DOUBTS_TEXT}
                    </Typography>
                    <WhatsAppIcon className="whatsapp-icon"
                        sx={{
                            color: "#5452ff",
                            fontSize: {xs: "4vw", sm: "1.5vw"},
                            marginBottom: {xs:"2vw", sm: "0.5vw"}
                        }}
                    />
                    <Typography
                        sx={{
                            color: 'gray',
                            fontFamily: 'Viga, sans-serif',
                            fontSize: {xs: "3vw", sm: "1vw"},
                            position: 'relative',
                            zIndex: 1,
                        }}
                    >
                        <a
                            href={URLS.CONTACT_US}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="whatsapp-link"
                        >
                            {ADDRESS_TEXTS.CONTACT_US_TEXT}
                        </a>
                        ───
                    </Typography>
                </div>
            </div>
        </Container>
    );
}

export default Address;